import { Button } from "@mui/material";
import { Add } from "@mui/icons-material";

export default function CreateButton({ onClick, children = "Create", variant = "contained", ...props }) {
  return (
    <Button
      variant={variant}
      size="medium"
      startIcon={<Add />}
      onClick={onClick}
      sx={{
        textTransform: "none",
        borderRadius: "8px",
        px: 3,
        height: "40px",
        backgroundColor: "#627CFB", 
        color: "#ffffff !important",
        opacity: 1,
        fontWeight: 500,
        boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
        "&:focus": {
          outline: "2px solid transparent",
          outlineOffset: "2px",
          boxShadow: "0 0 0 3px rgba(98, 124, 251, 0.5)", 
        },
        "&:disabled": {
          backgroundColor: "#d1d5db",
          color: "#9ca3af",
        },
      }}
      {...props}
    >
      {children}
    </Button>
  );
}
